/**
 * <TutorProfilePreview> — comment le masteur apparaît aux familles (molecule).
 *
 * L'en-tête de la fiche du tuteur (`TutorProfileCardHeader`) que l'étape « Personnalise ton
 * profil » montre sous « Tu apparaîtras de cette façon » : sa capsule, son nom, son établissement,
 * sa filière et son slogan, puis les matières qu'il se sent d'accompagner. L'aperçu suit ce que le
 * tuteur écrit, champ par champ.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Avatar } from "../../atoms/Avatar"
import { Badge } from "../../atoms/Badge"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"
import { type UITutorProfilePreview } from "../../../ports/primary/ui/types/tutorCompte"

export type TutorProfilePreviewProps = {
    preview: UITutorProfilePreview
    testID?: string
}

const AVATAR_SIZE = 64

export function TutorProfilePreview(props: TutorProfilePreviewProps) {
    const { preview, testID } = props

    return (
        <Card p="4" testID={testID}>
            <Row gap="4" align="start" style={styles.row}>
                <Avatar
                    variant="tutor"
                    uri={preview.avatarUrl ?? undefined}
                    name={preview.displayName}
                    size={AVATAR_SIZE}
                />
                <Stack gap="1" style={styles.body}>
                    <Text size="text-xl" weight="bold" color="primary">
                        {preview.displayName}
                    </Text>
                    {preview.studyInstitution !== "" && (
                        <Text weight="medium" color="text-muted">
                            {preview.studyInstitution}
                        </Text>
                    )}
                    <Text color="text-muted">{preview.bio}</Text>
                    {preview.chips.length > 0 && (
                        <Row gap="2" style={styles.chips}>
                            {preview.chips.map((chip) => (
                                <Badge key={chip} text={chip} variant="neutral" />
                            ))}
                        </Row>
                    )}
                </Stack>
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create((theme) => ({
    /** Le nœud de la capsule déborde sous l'avatar. */
    row: { paddingBottom: theme.spacing["1"] },
    body: { flex: 1, flexShrink: 1 },
    chips: { flexWrap: "wrap", marginTop: theme.spacing["2"] },
}))
